module.exports = __webpack_public_path__ + "img/amazon_linux_logo.7049213f.svg";